if (!customElements.get('zylo-videos')) {
  customElements.define('zylo-videos', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const track = this.querySelector('.zylo-videos__track');
      this.querySelectorAll('[data-video-direction]').forEach(button => {
        button.addEventListener('click', () => {
          const distance = (track.querySelector('.zylo-videos__card')?.getBoundingClientRect().width || track.clientWidth) + 18;
          track.scrollBy({left: Number(button.dataset.videoDirection) * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        });
      });
      this.querySelectorAll('video').forEach(video => {
        const media = video.closest('.zylo-videos__media');
        const overlay = media.querySelector('.zylo-videos__overlay');
        const toggles = media.querySelectorAll('[data-video-toggle]');
        const mute = media.querySelector('[data-video-mute]');
        const seek = media.querySelector('.zylo-videos__seek');
        const sync = () => {
          media.classList.toggle('is-playing', !video.paused && !video.ended);
          media.classList.toggle('is-muted', video.muted);
          toggles.forEach(button => { if (button.dataset.playLabel) button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel); });
          mute.setAttribute('aria-label', video.muted ? mute.dataset.unmuteLabel : mute.dataset.muteLabel);
          mute.setAttribute('aria-pressed', String(video.muted));
          seek.disabled = !Number.isFinite(video.duration) || video.duration <= 0;
          if (!seek.disabled) seek.value = video.currentTime / video.duration * 100;
        };
        const fallback = () => { overlay.hidden = true; video.controls = true; };
        const toggle = () => { if (video.paused) video.play().catch(fallback); else video.pause(); };
        toggles.forEach(button => button.addEventListener('click', toggle));
        video.addEventListener('click', () => { if (!overlay.hidden) toggle(); });
        mute.addEventListener('click', () => { video.muted = !video.muted; });
        seek.addEventListener('input', () => { if (Number.isFinite(video.duration)) video.currentTime = Number(seek.value) * video.duration / 100; });
        ['play', 'pause', 'ended', 'volumechange', 'loadedmetadata', 'timeupdate'].forEach(event => video.addEventListener(event, sync));
        video.addEventListener('play', () => {
          document.querySelectorAll('zylo-videos video').forEach(other => { if (other !== video) other.pause(); });
        });
        video.addEventListener('error', fallback);
        video.controls = false;
        overlay.hidden = false;
        sync();
      });
    }
  });
}
